import { withBemMod } from '@bem-react/core';

import { cnButton } from '../../Button.cn';

import './Button_view_clear.css';

export type WithViewClearProps = {
    view?: 'clear';
};

/**
 * @deprecated
 * Используйте view `ghost`
 */
export const withViewClear = withBemMod<WithViewClearProps>(cnButton(), {});
